<!-- eslint-disable vue/multi-word-component-names -->

<script setup>
import { ref } from 'vue';


let items = ref([
    "Auto Clave Tape",
    "Leukoplast Tape",
    "Microset",
    "Serum Set",
    "Anti-allergic Tape",
    "Powder-Free and Low-Powder Surgical Gloves",
    "Latex Examination Gloves",
    "Midwifery Gloves",
    "Syringe",
    "Blood Transfusion Set",
    "Sanitary Under Pad"
]);

let images = ref([
    "1.webp",
    "2.webp",
    "3.webp",
    "4.webp",
    "5.webp",
    "6.webp",
    "7.webp",
    "8.webp",
    "9.webp",
    "10.webp",
    "23.webp",
    "25.webp",
    "27.webp",
    "41.webp",
    "43.webp",
    "44.webp",
    "45.webp",
    "46.webp",
    "47.webp",
    "48.webp",
    "49.webp",
    "50.webp",
    "51.webp",
    "53.webp",
    "54.webp",
    "55.webp",
    "56.webp",
]);



</script>

<template>
   <main class="w-full h-auto my-2">

    <section class="container mx-auto h-auto flex flex-col justify-start items-center">
      <span class="font-bold text-xl">Products / Hospital products</span>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">
        <div class="w-full h-full col-span-1 flex justify-center items-center" v-for="(item,index) in items" :key="index">
            <div class="w-3 h-3 bg-sky-500 rounded-full"></div>
            <span class="mx-2">{{ item }}</span>
        </div>
      </section>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">

        <a download :href="`/Hospitalproducts/${item}`"  v-for="(item,index) in images" :key="index" class="w-full h-[250px] rounded-lg col-span-1 flex justify-center items-center">
            <img  :src="`/Hospitalproducts/${item}`" class="w-full h-full object-contain " alt="">
        </a>

      </section>

    </section>
  </main>
</template>

<style scoped></style>